<template>
  <div :key="componentKey">
    <!-- Material form login -->
    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form role="form" @submit.prevent="handleSubmit(handleSubmitAfterValidation)">
        <p class="h4 text-center mb-4">Sign in</p>
        <div class="grey-text">
          <label>Your Instagram email</label>
          <base-input alternative
                      class="mb-3"
                      name="Email"
                      :rules="{required: true, email: true}"
                      prepend-icon="ni ni-email-83"
                      placeholder="Your Instagram email"
                      v-model="user.email">
          </base-input>
          <br>
          <label>Your Instagram password</label>
          <base-input alternative
                      class="mb-3"
                      name="Password"
                      :rules="{required: true}"
                      prepend-icon="ni ni-lock-circle-open"
                      placeholder="Your Instagram password"
                      :type="type"
                      v-model="user.password">
          </base-input>

          <button type="button" @click="showPassword" style="background-color: Transparent;">
            <mdb-icon :icon=eyeIcon size="2x" class="ml-0" color="black"/>
          </button>
        </div>
        <div class="text-center" v-if="logged">
          <mdb-btn>Login</mdb-btn>
        </div>
      </form>
    </validation-observer>
    <div v-if="!logged">
      We are initiating your environment, this may take some time &#128525;&#128526;
      <progress-bar style="background-color: white"
                    :options="options"
                    :value="value"
      />
    </div>
    <mdb-container v-if="errorState">
      <mdb-alert :color="this.color">
        {{this.error}}
      </mdb-alert>
    </mdb-container>
    <mdb-modal :show="modal" @close="modal = false">
      <mdb-modal-header>
        <mdb-modal-title>Pin Confirmation for Instagram</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>Please enter the pin you just received in your email....</mdb-modal-body>
      <mdb-input v-model="pin" label="Your Instagram pin" icon="envelope"/>
      <mdb-modal-footer>
        <mdb-btn color="secondary" @click="pushPin" @click.native="modal = false">Send</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>


</template>

<script>
    import {
        mdbAlert,
        mdbBtn,
        mdbContainer,
        mdbInput,
        mdbModal,
        mdbIcon,
        mdbModalBody,
        mdbModalFooter,
        mdbModalHeader,
        mdbModalTitle
    } from 'mdbvue';
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';

    const option_struct = {
        text: {
            color: '#000000',
            shadowEnable: true,
            shadowColor: '#000000',
            fontSize: 14,
            fontFamily: 'Helvetica',
            dynamicPosition: false,
            hideText: false
        },
        progress: {
            color: '#2dbd2d',
            backgroundColor: '#C0C0C0'
        },
        layout: {
            height: 200,
            width: 140,
            verticalTextAlign: 55,
            horizontalTextAlign: 55,
            zeroOffset: 50,
            strokeWidth: 10,
            progressPadding: 0,
            type: 'circle'
        }
    };

    export default {
        name: "addUserCredentialsInstagram",
        data() {
            return {
                options: option_struct,
                eyeIcon: "eye",
                value: 0,
                type: "password",
                btnText: "Show Password",
                componentKey: 0,
                color: 'danger',
                pinSent: false,
                error: '',
                polling: null,
                progression_bar_intervall: null,
                pin: '',
                modal: false,
                logged: true,
                errorState: false,
                user: {
                    email: '',
                    name: this.$store.getters.getUser,
                    password: ''
                }
            }
        },
        components: {
            mdbInput,
            mdbContainer,
            mdbAlert,
            mdbIcon,
            mdbBtn,
            mdbModal,
            mdbModalHeader,
            mdbModalTitle,
            mdbModalBody,
            mdbModalFooter,
        },
        methods: {
            pushPin() {
                console.log(this.pin);
                this.pinSent = true;
                this.color = 'primary';
                this.error = 'Confirming the PIN, please wait...';
                const path = this.BACKEND_YSY + "/instagram/initPin";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                this.$http
                    .post(path, {
                        email_instagram: this.user.email,
                        ysy_username: this.user.name,
                        pin: this.pin,
                    }, {headers})
            },
            showPassword() {
                if (this.type === "password") {
                    this.type = "text";
                    this.eyeIcon = "eye-slash";
                } else {
                    this.type = "password";
                    this.eyeIcon = "eye";
                }
            },
            getUpdateState() {
                console.log('Starting - get update state');
                this.polling = setInterval(async () => {
                    this.logged = false;
                    const path = this.BACKEND_YSY + '/instagram/get-init-state';
                    let headers = {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${localStorage.id_token}`
                    };
                    await this.$http
                        .post(path, {
                            ysy_username: this.user.name,
                            email_instagram: this.user.email,
                        }, {headers})
                        .then(async res => {
                            console.log(res.data);
                            if (res.data.statusCode === 102 && this.pinSent === false) {
                                console.log('waiting pin');
                                this.errorState = true;
                                this.color = 'warning';
                                this.error = 'Waiting for the pin';
                                this.modal = true;
                            }
                            if (res.data.statusCode === 401) {
                                this.errorState = true;
                                this.error = "Hmm, that's not the right password. Please try again";
                                this.color = 'danger';
                                clearInterval(this.polling);
                                this.modal = false;
                                this.logged = true;
                                clearInterval(this.progression_bar_intervall);
                                this.value = 0
                            }
                            if (res.data.statusCode === 403) {
                                this.errorState = true;
                                this.error = "Hmm, that's not the right code";
                                this.color = 'danger';
                                clearInterval(this.polling);
                                this.modal = false;
                                this.logged = true;
                                clearInterval(this.progression_bar_intervall);
                                this.value = 0
                            }
                            if (res.data.statusCode === 200) {
                                this.errorState = true;
                                this.error = 'connected';
                                this.color = 'Your Instagram is linked';
                                clearInterval(this.polling);
                                clearInterval(this.progression_bar_intervall);
                                this.value = 0;
                                this.modal = false;
                                this.logged = true;
                                this.componentKey += 1;
                                this.$store.commit('setHaveAccountInstagram');
                                this.$store.commit('addInstagramAccount', this.user.email);
                                this.$router.push({name: 'Overview Instagram'})
                            }
                        })
                        .catch(async error => {
                            const self = this;
                            if (error.response.status === 401) {
                                console.error('Unauthorized', error.response.data);
                                await this.refreshIdToken().then(function (result) {
                                    console.log("res promise", result); // "Stuff worked!"
                                    self.getUpdateState()
                                }, function (err) {
                                    console.log("it broke", err); // Error: "It broke"
                                    self.$router.push({name: 'login'});
                                });
                            }
                        });

                }, 3000)
            },
            async handleSubmitAfterValidation() {
                if (this.$store.getters.getEmailInstagram.length > 1) {
                    swal.fire({
                        title: `Limit reached`,
                        text: 'You reached the maximum number of instagram accounts;' +
                            ' existing accounts are: ' + this.$store.getters.getEmailInstagram,
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-warning',
                        icon: 'warning'
                    });
                    return
                }
                console.log('Handling add instagram');
                this.logged = false;
                const path = this.BACKEND_YSY + "/trigger-init-user";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                await this.$http
                    .post(path, {
                        username: this.user.name,
                        email_instagram: this.user.email,
                        password_instagram: this.user.password,
                    }, {headers}).then(async res => {
                        console.log(res);
                        this.getUpdateState();
                        this.progression_bar_intervall = setInterval(this.move_progress_bar, 1500);
                    })
                    .catch(async error => {
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.handleSubmitAfterValidation()
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });
                        }
                    });
            },
            move_progress_bar() {
                if (this.value >= 100) {
                    clearInterval(this.progression_bar_intervall);
                    this.value = 0
                } else {
                    console.log(this.value);
                    this.value++;
                }
            },
        },
        created() {
            console.log(this.$store.state)
        },
        beforeDestroy() {
            clearInterval(this.polling);
        }
    }

</script>

<style>
</style>
